import { render, staticRenderFns } from "./CallbackThaid.vue?vue&type=template&id=2561d1c0&scoped=true"
import script from "./CallbackThaid.vue?vue&type=script&lang=js"
export * from "./CallbackThaid.vue?vue&type=script&lang=js"
import style0 from "./CallbackThaid.vue?vue&type=style&index=0&id=2561d1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561d1c0",
  null
  
)

export default component.exports